'use client';

import { ComponentPropsWithoutRef } from 'react';
import { Overlay } from '@/shared/ui/overlay';
import { useModalContext } from './modal-context';
import { useModalsStore } from './store';
import { useRemoveScroll } from './useRemoveScroll';

type Props = ComponentPropsWithoutRef<'div'> & {
    lockScroll?: boolean;
};
export const ModalOverlay = ({ children, onClick, lockScroll = true, className, ...props }: Props) => {
    const { isClosing, onClose, modalId } = useModalContext();
    const isServiceModal = useModalsStore((s) => modalId in s.data);
    useRemoveScroll(isServiceModal && lockScroll);

    const handleClick = () => {
        onClose('overlay');
    };

    return (
        <Overlay
            onClick={onClick || handleClick}
            isClosing={isClosing}
            className={!isServiceModal ? 'overlay__wrapper--inline' : className}
            {...props}
        >
            {children}
        </Overlay>
    );
};
